import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { Notification } from 'Components/frameworks/notification/Notification';
import { SeeMore } from 'Components/frameworks/see-more/SeeMore';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
type Props = {
  hasSeeMore?: boolean;
  icon?: string;
  linkLabel: string;
  linkUrl: string;
  message?: string;
  onClick?: () => void;
  seeLessLabel?: string;
  seeMoreLabel?: string;
};
export const CrisisAlert = ({
  hasSeeMore,
  icon = ICONS.WARNING,
  linkLabel,
  linkUrl,
  message,
  onClick,
  seeLessLabel,
  seeMoreLabel,
}: Props) => {
  if (!message) {
    return null;
  }

  const content = (
    <Notification className="text-sienna" iconName={icon} text={message}>
      <TextLink label={linkLabel} onClick={onClick} url={linkUrl} />
    </Notification>
  );

  if (hasSeeMore) {
    return (
      <SeeMore
        classNameButton="text-end"
        hasNoScrollOnCollapse
        isCollapseEnabled
        seeLessLabel={seeLessLabel}
        seeMoreLabel={seeMoreLabel}
        seeMoreSize={110}
      >
        {content}
      </SeeMore>
    );
  }

  return content;
};
